/* Imports */
import {
  h,
  resolveComponent,
} from 'vue';
import Main from '../views/Main.vue';

export default [{
  path: '/:locale/compare/',
  component: {
    render() {
      return h(resolveComponent('router-view'));
    },
  },
  children: [{
    path: '',
    name: 'main',
    component: Main,
  }, {
    path: '/:locale/:path/:pathMatch(.*)*',
    redirect: (to) => {
      const { locale } = to.params;
      return {
        path: `/${locale ?? 'en-US'}/${window?.AppData?.subdirectory ?? 'compare'}`,
      };
    },
  }],
}];
